<template>
    <!-- 关于我们——荣誉资质 -->
    <!-- pc端 -->
    <div v-if="isPCFlag">
        <!-- 第一部分顶部大图导航 -->
        <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

        <!-- <div class="containers"> -->

        <!-- 第二部分 -->
        <div class="containers">
            <div class="honor_header ">
                <h1 ref="HeaderTitle">荣誉资质</h1>
                <div ref="honorMain" class="mian_Info">
                    <p>
                        有收获，就有成长。
                        <br />
                        我们奋力拼搏，却不止步荣誉。
                        <br />
                        冲破桎梏的我们必将迎接更辉煌的未来！
                    </p>
                </div>
                <div class="honorImg" ref="honorImg">
                    <div class="shade" ref="shadeHonorImg"></div>
                    <img src="../../assets/imgs/about/honor.jpg" ref="imgHonorImg" />
                </div>
            </div>
        </div>

        <!-- new第三部分 -->
        <div class="credit_part">
            <div class="containers credit_main certificate_main">
                <img src="../../assets/imgs/about/high-techEnterprise.png" />
                <h1 class="marl300" ref="creditTitleNew">四川省高新技术企业</h1>
            </div>
        </div>

        <!-- 第三部分 -->
        <div class="credit_part certificate">
            <div class="containers credit_main">
                <h1 ref="creditTitle">3A信用证书</h1>
                <img src="../../assets/imgs/about/3Acredit.png" />
            </div>
        </div>

        <!-- 第四部分 -->
        <div class="credit_part">
            <div class="containers credit_main certificate_main">
                <img src="../../assets/imgs/about/zjtx.png" />
                <h1 class="marl300" ref="certificateTitle">四川省“专精特新”中小企业</h1>
            </div>
        </div>

        <!-- 第五部分 -->
        <div class="credit_part certificate">
            <div class="containers credit_main">
                <h1 ref="copyrightTitle">
                    DCMM二级证书
                </h1>
                <img src="../../assets/imgs/about/dcmm.png" />
            </div>
        </div>

        <!-- 第六部分 -->
        <div class="credit_part">
            <div class="containers credit_main certificate_main">
                <img src="../../assets/imgs/about/itss.png" />
                <h1 class="marl300" ref="ITSSTitle">ITSS三级证书</h1>
            </div>
        </div>

        <!-- 第七部分 -->
        <div class="credit_part certificate">
            <div class="containers credit_main">
                <h1 ref="cmmiTitle">
                    CMMI三级证书
                </h1>
                <img src="../../assets/imgs/about/cmmi.png" />
            </div>
        </div>

        <!-- 第八部分 -->
        <div class="credit_part">
            <div class="containers credit_main certificate_main">
                <img src="../../assets/imgs/about/software_copyright.png" />
                <h1 class="marl300" ref="softzzTitle">软件著作权证书</h1>
            </div>
        </div>

        <!-- 第九部分 -->
        <div class="ISOcredit_part">
            <div class="containers">
                <h1 ref="ISOcreditTitle">ISO体系证书</h1>
                <div class="ISOcredits">
                    <div>
                        <img src="../../assets/imgs/about/ISO-pic1.png" />
                        <div>ISO9001质量管理体系认证</div>
                    </div>
                    <div>
                        <img src="../../assets/imgs/about/ISO-pic2.png" />
                        <div>ISO14001环境管理体系认证</div>
                    </div>
                    <div>
                        <img src="../../assets/imgs/about/ISO-pic3.png" />
                        <div>ISO27001信息安全管理体系认证证书</div>
                    </div>
                    <div>
                        <img src="../../assets/imgs/about/ISO-pic4.png" />
                        <div>ISO45001职业健康安全管理体系认证</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 尾部公用组件 -->
        <bottomFooter></bottomFooter>
    </div>
    <!-- 移动端 -->
    <div v-else class="honorqualification-mobile">
        <!-- 第一部分顶部大图导航 -->
        <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitleMb" :menuLi="menuLi"></mobileTopBigPic>
        <!-- 第二部分 -->
        <div class="mobile-about-part2">
            <div class="title">
                荣誉资质
            </div>
            <div class="info container padding-bottom-213">
                有收获，就有成长。
                <br />
                我们奋力拼搏，却不止步荣誉。
                <br />
                冲破桎梏的我们必将迎接更辉煌的未来！
            </div>
            <div class="bg"></div>
        </div>
        <!-- new第三部分 -->
        <div class="mobile-about-part3-new about_bg">
            <div class="title">
                四川省高新技术企业
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <!-- 第三部分 -->
        <div class="mobile-about-part3">
            <div class="title">
                3A信用证书
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <!-- 第四部分 -->
        <div class="mobile-about-part4 about_bg">
            <div class="title">
                四川省“专精特新”中小企业
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <div class="mobile-about-part7 mobile-about-part">
            <div class="title">
                DCMM二级证书
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <div class="mobile-about-part8 mobile-about-part">
            <div class="title">
                ITSS三级证书
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <div class="mobile-about-part9 mobile-about-part">
            <div class="title">
                CMMI三级证书
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <!-- 第五部分 -->
        <div class="mobile-about-part5">
            <div class="title">
                软件著作权证书
            </div>
            <div class="title des-title">
                14个
            </div>
            <div class="bg mobile-container"></div>
        </div>
        <!-- 第六部分 -->
        <div class="mobile-about-part6 about_bg">
            <div class="title">
                ISO体系证书
            </div>
            <div class="iso-box">
                <img src="../../assets/imgs/about/ISO-pic1.png" />
                <div class="des">ISO9001质量管理体系认证</div>
            </div>
            <div class="iso-box">
                <img src="../../assets/imgs/about/ISO-pic2.png" />
                <div class="des">ISO14001环境管理体系认证</div>
            </div>
            <div class="iso-box">
                <img src="../../assets/imgs/about/ISO-pic3.png" />
                <div class="des">ISO27001信息安全管理体系认证证书</div>
            </div>
            <div class="iso-box">
                <img src="../../assets/imgs/about/ISO-pic4.png" />
                <div class="des">ISO45001职业健康安全管理体系认证</div>
            </div>
        </div>
        <!-- 尾部公用组件 -->
        <mobileBottomFooter></mobileBottomFooter>
    </div>
</template>

<script>
import topBigPic from "@/components/global/topBigPic.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import bottomFooter from "@/components/global/bottomFooter.vue";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import animationUtils from "@/utils/animationUtils.js";
import { isPC } from "@/utils/tools.js";

export default {
    name: "honorqualification",
    data() {
        return {
            isPCFlag: true,
            //顶部导航数据
            topBgImg: require("../../assets/imgs/about/honortop_bg.jpg"),
            mobileTopBgImg: require("../../assets/imgs/mbAbout/honorqualification/honortop_bg.jpg"),
            bigTitle: {
                znTitle: "荣誉资质",
                enTitle: "HONOUR&QUALIFICATION"
            },
            bigTitleMb: {
                znTitle: "荣誉资质",
                enTitle: "HONOUR AND QUALIFICATION"
            },
            menuLi: {
                sortOne: {
                    title: "关于我们",
                    children: [
                        {
                            name: "产品中心",
                            active: false,
                            url: "/comdedeauto"
                        },
                        {
                            name: "解决方案",
                            active: false,
                            url: "/solutionadmi"
                        },
                        {
                            name: "新闻动态",
                            active: false,
                            url: "/companyNews"
                        },
                        {
                            name: "关于我们",
                            active: true,
                            url: "/companyprofile"
                        },
                        {
                            name: "职等你来",
                            active: false,
                            url: "/jobmarket"
                        }
                    ]
                },

                sortTwo: {
                    title: "荣誉资质",
                    children: [
                        {
                            name: "公司简介",
                            active: false,
                            url: "/companyprofile"
                        },
                        {
                            name: "企业文化",
                            active: false,
                            url: "/companyculture"
                        },
                        {
                            name: "荣誉资质",
                            active: true,
                            url: "/honorqualification"
                        },
                        {
                            name: "联系我们",
                            active: false,
                            url: "/contactus"
                        }
                    ]
                }
            }
        };
    },
    created() {
        this.isPCFlag = isPC();
    },
    mounted() {
        this.isPCFlag ? window.addEventListener("scroll", this.menu) : "";
    },
    beforeDestroy() {
        //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
        this.isPCFlag ? window.removeEventListener("scroll", this.menu) : "";
    },
    methods: {
        //滚动条监听
        menu() {
            /**
             * animations方法的第一个参数是需要动画的dom元素的高度，
             * 第二个参数是需要加动画的dom元素的样式列表数组，
             * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
             */
            //第二部分标题动画
            let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let HeaderTitle = this.$refs.HeaderTitle.classList;
            //
            animationUtils.animations(HeaderTitleOffsetTop, HeaderTitle, "activeTitle");

            //第二部分图的动画
            let honorImgOffsetTop = this.$refs.honorImg.offsetTop; //获取当前元素距离文档顶部的高度
            let shadeHonorImg = this.$refs.shadeHonorImg.classList; //遮罩样式数组
            let imgHonorImg = this.$refs.imgHonorImg.classList; //图片样式数组
            animationUtils.animations(honorImgOffsetTop, shadeHonorImg, "activeShade");
            animationUtils.animations(honorImgOffsetTop, imgHonorImg, "activeImg");

            //第二部分文字描述动画
            let honorMainOffsetTop = this.$refs.honorMain.offsetTop;
            let honorMainClassList = this.$refs.honorMain.classList;
            animationUtils.animations(honorMainOffsetTop, honorMainClassList, "activeTitle");

            //new第三部分标题动画
            let creditTitleNewOffsetTop = this.$refs.creditTitleNew.offsetTop; //获取当前元素距离文档顶部的高度
            let creditTitleNew = this.$refs.creditTitleNew.classList;
            //
            animationUtils.animations(creditTitleNewOffsetTop, creditTitleNew, "activeTitle");

            //第三部分标题动画
            let creditTitleOffsetTop = this.$refs.creditTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let creditTitle = this.$refs.creditTitle.classList;
            //
            animationUtils.animations(creditTitleOffsetTop, creditTitle, "activeTitle");

            //第四部分标题动画
            let certificateTitleOffsetTop = this.$refs.certificateTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let certificateTitle = this.$refs.certificateTitle.classList;
            //
            animationUtils.animations(certificateTitleOffsetTop, certificateTitle, "activeTitle");

            //第五部分标题动画
            let copyrightTitleOffsetTop = this.$refs.copyrightTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let copyrightTitle = this.$refs.copyrightTitle.classList;
            //
            animationUtils.animations(copyrightTitleOffsetTop, copyrightTitle, "activeTitle");

            //第六部分标题动画
            let ITSSTitleOffsetTop = this.$refs.ITSSTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let ITSSTitle = this.$refs.ITSSTitle.classList;
            //
            animationUtils.animations(ITSSTitleOffsetTop, ITSSTitle, "activeTitle");

            //第七部分标题动画
            let cmmiTitleOffsetTop = this.$refs.cmmiTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let cmmiTitle = this.$refs.cmmiTitle.classList;
            //
            animationUtils.animations(cmmiTitleOffsetTop, cmmiTitle, "activeTitle");

            //第八部分标题动画
            let softzzTitleOffsetTop = this.$refs.softzzTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let softzzTitle = this.$refs.softzzTitle.classList;
            //
            animationUtils.animations(softzzTitleOffsetTop, softzzTitle, "activeTitle");

            //第九部分标题动画
            let ISOcreditTitleOffsetTop = this.$refs.ISOcreditTitle.offsetTop; //获取当前元素距离文档顶部的高度
            let ISOcreditTitle = this.$refs.ISOcreditTitle.classList;
            //
            animationUtils.animations(ISOcreditTitleOffsetTop, ISOcreditTitle, "activeTitle");
        }
    },
    components: {
        topBigPic,
        mobileTopBigPic,
        bottomFooter,
        mobileBottomFooter
    }
};
</script>

<style lang="scss" scoped>
.honorqualification-mobile {
    width: 1920px;
    .marlr {
        margin: 0 71.11px;
    }
    .mobile-container {
        width: 1778px;
        margin: 0 auto;
    }
    .about_bg {
        background: #f9f9f9;
    }
    .padding-bottom-213 {
        padding-bottom: 213px;
    }
    .padding-bottom-219 {
        padding-bottom: 219px;
    }
    .mobile-about-part2,
    .mobile-about-part3,
    .mobile-about-part3-new,
    .mobile-about-part4,
    .mobile-about-part,
    .mobile-about-part5 {
        padding-bottom: 284px;
        .title {
            width: 1720px;
            height: 188px;
            line-height: 188px;
            font-size: 156px;
            font-weight: 600;
            padding: 284px 0 210px;
            box-sizing: content-box;
            margin-left: 71.11px;
            color: #000000;
        }
        .bg {
            height: 1152px;
        }
    }
    .mobile-about-part2 {
        .title {
            width: 1720px;
            height: 180px;
            line-height: 180px;
            font-size: 156px;
            font-weight: 600;
            padding: 206px 0 107px;
            box-sizing: content-box;
            margin-left: 71.11px;
            color: #000000;
        }
        .bg {
            background: url(../../assets/imgs/mbAbout/honorqualification/honor.jpg) no-repeat;
            background-size: cover;
        }
        .info {
            font-size: 71px;
            font-weight: 400;
            color: #323333;
            line-height: 128px;
            text-align: justify;
        }
    }
    .mobile-about-part3-new {
        .bg {
            background: url(../../assets/imgs/about/high-techEnterprise.png) no-repeat;
            background-size: cover;
        }
    }
    .mobile-about-part3 {
        .bg {
            background: url(../../assets/imgs/about/3Acredit.png) no-repeat;
            background-size: cover;
        }
    }
    .mobile-about-part4 {
        .bg {
            background: url(../../assets/imgs/mbAbout/honorqualification/zjtx.png) no-repeat;
            background-size: cover;
        }
    }
    .mobile-about-part7 {
        .bg {
            background: url(../../assets/imgs/about/dcmm.png) no-repeat;
            background-size: 100% auto;
        }
    }
    .mobile-about-part8 {
        .bg {
            background: url(../../assets/imgs/about/itss.png) no-repeat;
            background-size: 100% auto;
        }
    }
    .mobile-about-part9 {
        .bg {
            background: url(../../assets/imgs/about/cmmi.png) no-repeat;
            background-size: 100% auto;
        }
    }
    .mobile-about-part5 {
        .bg {
            background: url(../../assets/imgs/mbAbout/honorqualification/software_copyright.png) no-repeat;
            background-size: cover;
        }
        .title {
            padding: 206px 0 0px;
        }
        .des-title {
            padding: 96px 0 107px;
        }
    }
    .mobile-about-part6 {
        .title {
            width: 1720px;
            height: 188px;
            line-height: 188px;
            font-size: 156px;
            font-weight: 600;
            padding: 284px 0 210px;
            box-sizing: content-box;
            margin-left: 71.11px;
            color: #000000;
        }
        .bg {
            height: 1724px;
        }
        .iso-box {
            display: grid;
            place-content: center;
            img {
                height: 1767px;
                width: auto;
            }
            .des {
                height: 68px;
                font-size: 71px;
                margin-top: 70px;
                color: #000000;
                padding-bottom: 213px;
            }
        }
    }
}
</style>
